import '@fontsource/golos-text/400.css';
import '@fontsource/golos-text/500.css';
import '@fontsource/golos-text/600.css';
import '@fontsource/golos-text/700.css';
import '@fontsource/literata/600.css';
import './styles/tokens.css';
import './styles/base.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { createAppServices } from './app/services';
import { applyTheme, readThemePreference, resolveTheme } from './app/theme/ThemeProvider';
import { prefetchSectionForPath } from './app/registry';
import { createI18n, loadCoreNamespaces } from './i18n';

applyTheme(resolveTheme(readThemePreference()));

const i18n = createI18n();
const services = createAppServices({ i18n });
const container = document.getElementById('app-root');
if (!container) throw new Error('Root element #app-root not found');

/*
 * Параллельно, до первой отрисовки (НФТ-06): проверка сессии по refresh-cookie, код и переводы раздела
 * из адреса, базовые переводы текущего языка. Отрисовка ждёт только переводы.
 */
void services.session.bootstrap();
prefetchSectionForPath(window.location.pathname, i18n);

function render(): void {
  createRoot(container as HTMLElement).render(
    <StrictMode>
      <App services={services} />
    </StrictMode>,
  );
}

loadCoreNamespaces(i18n).then(render, render);
